export default {"src":"/_next/static/media/like-icon.d7e17a60.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};